export default __webpack_public_path__ + "static/media/avatar-image.6f6818b0.svg";